<template>
  <div class="mine">
    <div class="header-section">
      <div class="user-info">
        <van-image class="avatar" round width="70" height="70" :src="userInfo.avatar || defaultAvatar" />
        <div class="info-content">
          <div class="name-row">
            <div class="nickname">{{ userInfo.name || '-' }}</div>
          </div>
          <div class="mobile">{{ maskedPhone }}</div>
        </div>
      </div>
    </div>

    <div class="menu-section">
      <van-cell-group inset>
        <!--
        <van-cell title="切换角色" is-link icon="manager-o" @click="handleSwitchRole" />
        -->
        <van-cell title="账号设置" is-link icon="setting-o" @click="handleAccountSetting" />
        <van-cell title="联系客服" is-link icon="service-o" @click="handleContact" />
      </van-cell-group>
    </div>

    <div class="logout-btn">
      <van-button block plain type="danger" @click="handleLogout">退出登录</van-button>
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import { getCleanerInfo } from '../../api/lxz/cleaner'

const SERVICE_PHONE = '4008825662'

export default {
  name: 'CleanerMine',
  data() {
    return {
      userInfo: {
        name: '',
        phone: '',
        avatar: ''
      },
      storeList: [],
      defaultAvatar: require('@/assets/images/avatar.png')
    }
  },
  computed: {
    maskedPhone() {
      const phone = this.userInfo && this.userInfo.phone != null ? String(this.userInfo.phone) : ''
      const normalized = phone.replace(/\s+/g, '')
      if (/^\d{11}$/.test(normalized)) return normalized.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2')
      return phone || '-'
    }
  },
  created() {
    this.getCleanerInfo()
  },
  methods: {
    async getCleanerInfo() {
      const res = await getCleanerInfo()
      if (res.status === 200) {
        const { cleanerInfo } = res.data || {}
        this.userInfo = cleanerInfo.user || {}
      }
    },

    handleSwitchRole() {
      Toast('暂未接入角色切换页面')
    },
    handleAccountSetting() {
      Toast('保洁端暂无账号设置')
    },
    handleContact() {
      window.location.href = `tel:${SERVICE_PHONE.replace(/-/g, '')}`
    },
    async handleLogout() {
      try {
        await Dialog.confirm({ title: '提示', message: '确定要退出登录吗？' })
      } catch (e) {
        return
      }
      localStorage.removeItem('lxz-token')
      sessionStorage.removeItem('code')
      Toast.success('已退出')
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.mine {
  min-height: 100vh;
  background: #f5f7fa;
  padding-bottom: 12px;
}
.header-section {
  background: linear-gradient(135deg, #41a863 0%, #2b9939 100%);
  padding: 24px 16px 40px;
}
.user-info {
  display: flex;
  align-items: center;
}
.avatar {
  margin-right: 12px;
  border: 2px solid rgba(255, 255, 255, 0.35);
}
.info-content {
  color: #fff;
  min-width: 0;
}
.name-row {
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}
.nickname {
  font-size: 18px;
  font-weight: 700;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 240px;
}
.mobile {
  font-size: 14px;
  opacity: 0.9;
}
.menu-section {
  margin-top: -24px;
}
.logout-btn {
  margin: 12px 16px 0;
}
</style>
